export const CLIENT_LINK_QRCODE_DIALOG = {
  SET_INITIAL_SHOW:'CLIENT_LINK_QRCODE_DIALOG.SET_INITIAL_SHOW',
  SET_INITIAL_QRCODE_API_URL:'CLIENT_LINK_QRCODE_DIALOG.SET_INITIAL_QRCODE_API_URL',
  SET_INITIAL_QRCODE_API_URL_LINK:'CLIENT_LINK_QRCODE_DIALOG.SET_INITIAL_QRCODE_API_URL_LINK',
}